import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function AbstractPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Abstract</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p style={{ fontSize: "1.2em" }}>
              Large-scale land cover changes leading to land degradation and
              deforestation in fragile ecosystems such as the Western Ghats have
              impaired ecosystem services, evident from the conversion of
              perennial water bodies to seasonal, which necessitates an
              understanding of forest structure dynamics with ecosystem services
              to evolve appropriate location-specific mitigation measures to
              arrest land degradation. The current study evaluates the extent
              and condition of forest ecosystems in Goa of the central Western
              Ghats, a biodiversity hotspot. Land use dynamics is assessed
              through a supervised hierarchical classifier based on the Random
              Forest Machine Learning Algorithm, revealing that total forest
              cover declined by 3.75% during the post-1990s due to market forces
              associated with globalization. Likely land uses predicated through
              the CA-Markov-based Analytic Hierarchy Process (AHP) highlight a
              decline in evergreen forest cover of 10.98%. The carbon
              sequestration potential of forests in Goa assessed through the
              InVEST model highlights the storage of 53,384.11 Gg of carbon,
              which accounts for 373.47 billion INR (4.49 billion USD). The
              total ecosystem supply value (TESV) for forest ecosystems was
              computed by aggregating the provisioning, regulating, and cultural
              services, which accounts for 481.76 billion INR per year. TESV
              helps in accounting for the degradation cost of ecosystems towards
              the development of green GDP (Gross Domestic Product).
              Prioritization of Ecologically Sensitive Regions (ESR) considering
              bio-geo-climatic, ecological, and social characteristics at
              disaggregated levels reveals that 54.41% of the region is highly
              sensitive (ESR1 and ESR2). The outcome of the research offers
              invaluable insights for the formulation of strategic natural
              resource management approaches.
              <br />
              <b>Keywords</b> : Land use, land cover, Land use change
              prediction, agent-based modeling, carbon sequestration, InVEST
              model, ecosystem services, Ecologically Sensitive Regions (ESR),
              Western Ghats
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default AbstractPage;
